import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComplianceSuiteComponent } from './compliance-suite.component';
import { ComplianceSuiteRoutingModule } from "./compliance-suite-routing.module";
import { TranslatePipe } from "@ngx-translate/core";

@NgModule({
  declarations: [
    ComplianceSuiteComponent
  ],
  imports: [
    CommonModule,
    ComplianceSuiteRoutingModule,
    TranslatePipe
  ]
})
export class ComplianceSuiteModule { }

